import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from "@material-ui/core/Checkbox";
import { Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const ProductsTable = ({ userProducts, allProducts, oldProduct, setOldProduct, newProduct, setNewProduct, onSubmitCallback, onBack }) => {
    const handleToggle = (value) => () => {
        if (oldProduct === value) {
            setOldProduct(null);
        } else {
            setOldProduct(value);
        }
    };
    const handleChange = (event) => {
        const newProduct = allProducts.find(product => product.id === event.target.value);
        setNewProduct(newProduct);
    };

    const handleSubmit = () => {
        if (!newProduct || !oldProduct) {
            return;
        }
        onSubmitCallback();
    };

    return userProducts.length > 0 ? (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                Products found for the customer
            </Typography>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <TableCell>ID #</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Description</TableCell>
                            {/* <TableCell>Type</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {userProducts.map((product, index) => (
                            <TableRow key={`${product.id}-${index}`} onClick={handleToggle(product)}>
                                <TableCell padding="checkbox">
                                    <Checkbox checked={oldProduct === product} />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {product.id}
                                </TableCell>
                                <TableCell>{product.name}</TableCell>
                                <TableCell>{product.description}</TableCell>
                                {/* <TableCell>{product.type}</TableCell> */}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className="mt-25">
                <Typography variant="h6" gutterBottom>
                    Replace with
                </Typography>
                <div className="mt-25">
                    <FormControl className="w-100 mt-25">
                        <Select value={newProduct?.id || 0} onChange={handleChange}>
                            <MenuItem value={0}>Select new product</MenuItem>
                            {allProducts.filter(p => userProducts.findIndex(r => r.id == p.id) == -1).map((product, index) => (
                                <MenuItem key={`${product.id}-${index}`} value={product.id}>{product.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </div>
            <div className="mt-50">
                <button className="button save-btn accent mr-1"
                    onClick={onBack}>
                    Back
                </button>
                <button className="button save-btn accent"
                    onClick={handleSubmit}>
                    Swap products
                </button>
            </div>
        </React.Fragment>)
        :
        <div className="mt-50">
            <p>Customer Does Not Have Any Active Products!</p>
            <button className="button save-btn accent mr-1"
                onClick={onBack}>
                Back
            </button>
        </div>
        ;
};

export default ProductsTable;